import dayjs from 'dayjs'

import { useSystemTime } from '@eastcoal/shared/hooks/useSystemTime'

import {
  TradeSessionStatus,
  TradeSessionStatusColorMap,
  TradeSessionStatusTextMap
} from '../../enums/TradeSessionStatus'

import {
  TradeSessionStatusInfo,
  UseTradeSessionStatusInfoProps
} from './interface'

export const useTradeSessionStatusInfo = ({
  startTime: bidStartTime,
  endTime: bidEndTime,
  signUpStartTime,
  signUpEndTime
}: UseTradeSessionStatusInfoProps): TradeSessionStatusInfo => {
  const systemTime = useSystemTime(state => state.currentSystemTime)

  const bidStartDayjs = dayjs(bidStartTime)

  // 先判断出价状态，只有在出价未开始时才判断报名状态
  if (bidStartDayjs.isAfter(systemTime)) {
    // 只有比价有报名时间
    if (signUpStartTime && signUpEndTime) {
      const signUpStartDayjs = dayjs(signUpStartTime)
      const signUpEndDayjs = dayjs(signUpEndTime)

      // 还没开始报名
      if (signUpStartDayjs.isAfter(systemTime)) {
        return {
          status: TradeSessionStatus.WAIT_APPLY_START,
          statusText:
            TradeSessionStatusTextMap[TradeSessionStatus.WAIT_APPLY_START],
          statusColor:
            TradeSessionStatusColorMap[TradeSessionStatus.WAIT_APPLY_START],
          timeLabel: '距开始',
          duration: dayjs.duration(signUpStartDayjs.diff(systemTime))
        }
      }

      // 正在报名
      if (signUpEndDayjs.isAfter(systemTime)) {
        return {
          status: TradeSessionStatus.APPLYING,
          statusText: TradeSessionStatusTextMap[TradeSessionStatus.APPLYING],
          statusColor: TradeSessionStatusColorMap[TradeSessionStatus.APPLYING],
          timeLabel: '距截止',
          duration: dayjs.duration(signUpEndDayjs.diff(systemTime))
        }
      }
    }

    // 出价未开始
    return {
      status: TradeSessionStatus.WAIT_BID_START,
      statusText: TradeSessionStatusTextMap[TradeSessionStatus.WAIT_BID_START],
      statusColor:
        TradeSessionStatusColorMap[TradeSessionStatus.WAIT_BID_START],
      timeLabel: '距开始',
      duration: dayjs.duration(bidStartDayjs.diff(systemTime))
    }
  }

  const bidEndDayjs = dayjs(bidEndTime)

  // 正在出价
  if (bidEndDayjs.isAfter(systemTime)) {
    return {
      status: TradeSessionStatus.BIDDING,
      statusText: TradeSessionStatusTextMap[TradeSessionStatus.BIDDING],
      statusColor: TradeSessionStatusColorMap[TradeSessionStatus.BIDDING],
      timeLabel: '距结束',
      duration: dayjs.duration(bidEndDayjs.diff(systemTime))
    }
  }

  // 出价结束
  return {
    status: TradeSessionStatus.BID_END,
    timeLabel: '结束时间',
    statusText: TradeSessionStatusTextMap[TradeSessionStatus.BID_END],
    statusColor: TradeSessionStatusColorMap[TradeSessionStatus.BID_END],
    duration: dayjs.duration(0)
  }
}
